import { ModuleFE_Coralogix } from './modules/ModuleFE_Coralogix.js';
export const ModulePackFE_Coralogix = [
    ModuleFE_Coralogix
];
//# sourceMappingURL=module-pack.js.map